export default {
  register: {
    title: 'Registrarse',
    username: 'Nombre de Usuario',
    phone: 'Número de Teléfono',
    phoneCode: 'Código',
    email: 'Correo Electrónico',
    password: 'Contraseña',
    captcha: 'Captcha',
    smsCode: 'Código SMS',
    emailCode: 'Código de Correo',
    verificationCode: 'Código de correo',
    invitationCode: 'Código de Invitación',
    loading: 'Cargando...',
    send: 'Enviar',
    sendCode: 'Enviar Código',
    signUp: 'Registrarse',
    contactUs: '¿Contáctanos？',
    haveAccount: '¿Ya tienes cuenta?',
    signIn: 'Iniciar Sesión',
    loginNow: 'Iniciar Sesión',
    or: 'O',
    orSignUpWith: 'O regístrate con',
    methodUsername: 'Nombre de usuario',
    methodPhone: 'Teléfono',
    methodEmail: 'Correo',
    codeOptional: 'Código (Opcional)',
    privacyPolicy: 'Confirmo que tengo más de 18 años y acepto la',
    privacyPolicyLink: 'Política de Privacidad',
    and: 'y',
    termsConditions: 'Términos y Condiciones',
    vault: 'Bóveda',
    receivePromos: 'Recibir Promociones por Correo',
    usernameRequired: 'El nombre de usuario es obligatorio',
    usernameInvalid: 'El nombre de usuario solo puede contener letras, números y guiones bajos',
    phoneRequired: 'El número de teléfono es obligatorio',
    phoneInvalid: 'Formato de número de teléfono inválido',
    emailRequired: 'El correo electrónico es obligatorio',
    emailInvalid: 'Formato de correo electrónico inválido',
    passwordRequired: 'La contraseña es obligatoria',
    passwordInvalid: 'La contraseña no cumple con los requisitos',
    captchaRequired: 'El captcha es obligatorio',
    smsCodeRequired: 'El código SMS es obligatorio',
    emailCodeRequired: 'El código de correo es obligatorio',
    privacyPolicyRequired: 'Por favor acepta la Política de Privacidad y los Términos y Condiciones',
    passwordHintLow: 'Al menos 6 dígitos',
    passwordHintMedium: 'Al menos 6 caracteres con letras y números',
    passwordHintHigh: 'Al menos 6 caracteres con letras, números y símbolos',
    // Format validation
    usernameFormat: 'Solo letras, números y _',
    emailFormat: 'Formato de correo inválido',
    // Toast messages
    smsCodeSent: 'Código SMS enviado',
    emailCodeSent: 'Código de correo enviado',
    smsCodeFailed: 'Error al enviar código SMS',
    emailCodeFailed: 'Error al enviar código de correo',
    registerSuccess: 'Registro exitoso',
    registerFailed: 'Registro fallido',
    // Google sign in
    signInWithGoogle: 'Iniciar sesión con Google+'
  }
};
